import { render, staticRenderFns } from "./AccountPersonalData.vue?vue&type=template&id=470c53fe"
import script from "./AccountPersonalData.vue?vue&type=script&lang=js"
export * from "./AccountPersonalData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports